import type { Cost } from "./costTypes";

export function filterCosts(costs: Cost[], query: string) {
  if (query.length === 0) {
    return costs;
  }
  return costs.filter(
    (c) =>
      costIdMatches(c, query) ||
      orderNameMatches(c, query) ||
      orderIdMatches(c, query) ||
      costDateMatches(c, query) ||
      providerNameMatches(c, query) ||
      invoiceNumberMatches(c, query) ||
      toBePaidMatches(c, query) ||
      customerNameMatches(c, query),
  );
}

function costIdMatches(cost: Cost, query: string) {
  return cost.id.toLowerCase().includes(query);
}

function orderNameMatches(cost: Cost, query: string) {
  return cost.order.name?.toLowerCase().includes(query);
}

function orderIdMatches(cost: Cost, query: string) {
  return cost.order.id.userFriendlyId?.toString().includes(query);
}

function costDateMatches(cost: Cost, query: string) {
  return cost.date.includes(query);
}

function providerNameMatches(cost: Cost, query: string) {
  return cost.provider?.name?.toLowerCase().includes(query);
}

function customerNameMatches(cost: Cost, query: string) {
  return cost.customer.name?.toLowerCase().includes(query);
}

function invoiceNumberMatches(cost: Cost, query: string) {
  return cost.invoices.some((i) => i.invoiceNumber?.toLowerCase().includes(query));
}

function toBePaidMatches(cost: Cost, query: string) {
  return cost.totalAmount.toString().includes(query);
}
